import { Close } from '@mui/icons-material';
import { Button, Dialog } from '@mui/material';
import {
  ModalContainer,
  Header,
  Body,
  ButtonContainer2,
  FloatingClose,
  acceptButton2,
  cancelButton2,
  titleStyle,
} from '../style';
import { Translation } from '../hooks/useRolesCreatePage';

interface Props {
  translation: Translation;
  open: boolean;
  onAccept?: () => void;
  onCancel?: () => void;
}

function ModalConfirm({ translation, open, onAccept, onCancel }: Props) {
  return (
    <div>
      <Dialog fullWidth maxWidth="sm" open={open} onClose={onCancel} className="col">
        <ModalContainer>
          <Header>
            <FloatingClose>
              <Close sx={{ width: 25, height: 25 }} onClick={onCancel} />
            </FloatingClose>
          </Header>
          <Body>
            <div style={titleStyle}>{translation.modal.title}</div>
            <p>{translation.modal.content}</p>
          </Body>
          <ButtonContainer2>
            <Button variant="outlined" color="success" style={cancelButton2} onClick={onCancel}>
              {translation.cancel}
            </Button>
            <Button variant="contained" color="success" style={acceptButton2} onClick={onAccept}>
              {translation.save}
            </Button>
          </ButtonContainer2>
        </ModalContainer>
      </Dialog>
    </div>
  );
}

export default ModalConfirm;
